import styled, { css } from 'styled-components';

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TabList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  column-gap: 5px;
  row-gap: 1px;
`;

export const TabItem = styled.div`
  user-select: none;
  padding: 0.5rem 0.8rem;
  color: ${({ theme }) => theme.tabs.label};
  background: ${({ theme }) => theme.tabs.background};
  border: 1px transparent;
  position: relative;
  border-style: solid solid none solid;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  cursor: pointer;
  text-align: center;

  ${({ active }) =>
    !active &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.tabs.border};
    `}

  ${({ active }) =>
    active &&
    css`
      cursor: default;
      font-weight: 600;
      color: ${({ theme }) => theme.tabs.labelActive} !important;
      background: ${({ theme }) => theme.tabs.backgroundActive};
    `}
`;

export const TabIcon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  font-size: 1rem;
  padding: 5px;
  color: ${({ active, theme }) => active && theme.header};
`;

export const PopOutIcon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  cursor: pointer;
  font-size: 1rem;
  padding: 5px;
  color: ${({ theme }) => theme.header};
`;

export const HeaderOptions = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
  margin-right: 10px;
  padding-bottom: 5px;
`;
